import React from 'react';
import Header from './component/header';
import About from './component/about';
import Personalize from './component/personalize';
import Driver from './component/driver';
import Setup from './component/setup';
import Booking from './component/booking';
import Footer from './component/footer';


class App extends React.Component {
  state = {
    carColor: 'black',
  }

  handlerSelectedColorCar = (color) => {
    this.setState({carColor: color})
  }

  render(){
    return (
      <React.Fragment>
        <Header />
        <About />
        <Personalize />
        <Driver />
        <Setup onChangeColor={this.handlerSelectedColorCar}/>
        <Booking selectedColor={this.state.carColor} />
        <Footer />
      </React.Fragment>
    );
  }
}

export default App;
